declare global {
  interface Window {
    __SB_AUTH_USE_LOCALSTORAGE_FOR_TESTS?: boolean;
    Cypress?: unknown;
  }
}

const TEST_FLAG_KEY = "__SB_AUTH_USE_LOCALSTORAGE_FOR_TESTS";

// Whether the Auth0 SPA SDK should run in `cacheLocation: 'localstorage'`
// instead of the default `'memory'`. Returns true only inside test
// harnesses:
//   - Cypress: window.Cypress is naturally truthy in Cypress browsers.
//   - Playwright: global-setup sets window.__SB_AUTH_USE_LOCALSTORAGE_FOR_TESTS
//     and mirrors it into localStorage so the flag survives storageState.json
//     into worker pages (where addInitScript does not run).
// Either signal flips the SDK into localStorage cache mode. Production code
// never sets these, so prod users keep cookies-only memory caching.
export function shouldUseLocalStorageAuthCache(): boolean {
  if (window.Cypress) return true;
  if (window.__SB_AUTH_USE_LOCALSTORAGE_FOR_TESTS) return true;
  try {
    return window.localStorage.getItem(TEST_FLAG_KEY) === "true";
  } catch {
    return false;
  }
}
